import { motion, AnimatePresence } from 'framer-motion';
import { headerStyles } from "./Header";
import CrossIcon from '../assets/cross.svg';
import CheckIcon from '../assets/check.svg';
import { globalStyles } from "../styles";
import { getFixedText } from '../utils';
import { onboardSteps } from './Start/constants';

interface IInfoModal {
    isShow: boolean;
    toggleShow: () => void;
}

export const InfoModal = ({ isShow, toggleShow }: IInfoModal) => {
    const renderMenu = (text: string) => {
        return (
            <div className="flex items-start gap-4 mb-3">
                <img src={CheckIcon} alt="Галочка" />
                <p className="text-[15px] font-normal leading-[18px]">{getFixedText(text)}</p>
            </div>
        )
    }

    return (
        <AnimatePresence>
            {isShow && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 select-none"
                >
                    <motion.div
                        initial={{ y: "100%", opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: "100%", opacity: 0 }}
                        transition={{ type: "spring", damping: 25, stiffness: 500 }}
                        className="bg-white p-6 rounded-2xl w-full max-w-[358px] max-h-full overflow-auto mx-auto absolute"
                    >
                        <button
                            onClick={toggleShow}
                            className={`${headerStyles.iconBox} right-4 top-4 bg-vkusvill-green absolute`}
                        >
                            <img src={CrossIcon} alt="close" className="mx-auto" />
                        </button>
                        <div className="mt-12 mb-6">
                            <h2 className={globalStyles.title}>{getFixedText('Как мы следим за качеством и безопасностью продуктов')}</h2>
                        </div>
                        <div className="space-y-3">
                            {onboardSteps.map((el, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.1 }}
                                >
                                    {renderMenu(el)}
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}